import { render, staticRenderFns } from "./NoPreferredAgent.vue?vue&type=template&id=0b2797c8"
import script from "./NoPreferredAgent.vue?vue&type=script&lang=js"
export * from "./NoPreferredAgent.vue?vue&type=script&lang=js"
import style0 from "./NoPreferredAgent.vue?vue&type=style&index=0&id=0b2797c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports